import { LoadingOutlined } from '@ant-design/icons';
import { Spin } from 'antdV3';

export const LoadingSpinner = () => {
  return (
    <Spin
      indicator={<LoadingOutlined style={{ fontSize: 16 }} spin onPointerEnterCapture={undefined} onPointerLeaveCapture={undefined} />}
    />
  );
};
